import React from 'react';
import { motion } from 'framer-motion';
import { HiStar } from 'react-icons/hi';

const testimonials = [
  {
    name: 'Emanuel Okello',
    role: 'Software Engineer & Project Manager',
    company: 'GitStart',
    testimonial:
      'Wajiha impressed me with her technical skills, commitment, and teamwork spirit. She has shown her potential through projects completed in MERN stack, Next.js, GraphQL, and PostgreSQL. As a PM, I could always count on her for deadlines with the highest quality standards. Her most admirable quality is the zeal to empower others through her advocacy as a Code to Inspire alumna. Wajiha is one of those rare combinations of technical talent, leadership, and compassion.',
    rating: 5,
  },
  {
    name: 'Corentin Trebaol',
    role: 'COO at GitStart (YC S19)',
    company: 'GitStart',
    testimonial:
      'From working as a seamstress to buy her first computer to acing university exams despite having a full time job, Wajiha shows Hollywood levels of perseverance and intelligence. At GitStart, she climbed levels in record time. She\'s an incredible person and computer engineer. I feel honored to have worked with her and would fight hard to get her into my team any day.',
    rating: 5,
  },
  {
    name: 'Happiness Ncube',
    role: 'Software Engineer & Team Lead',
    company: 'GitStart',
    testimonial:
      'Wajiha consistently demonstrated exceptional technical proficiency in React.js, JavaScript, and TypeScript. Her expertise was instrumental in creating highly responsive and user-friendly interfaces. Beyond her technical skills, Wajiha is an excellent communicator and team player. She actively participated in code reviews and effectively communicated technical concepts to both technical and non-technical stakeholders.',
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-charcoal-900 via-navy-900 to-charcoal-800 text-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/3 left-1/4 w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 bg-beige-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 right-1/4 w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 bg-navy-400 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 relative z-10">
        <motion.div
          className="text-center mb-10 sm:mb-12 md:mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-beige-400 font-semibold text-xs sm:text-sm uppercase tracking-wider">
            What People Say
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-2 font-primary">
            Testimonials & Recommendations
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-beige-500 mx-auto mt-3 sm:mt-4"></div>
          <p className="mt-4 sm:mt-6 text-gray-300 max-w-2xl mx-auto text-sm sm:text-base px-4">
            Feedback from colleagues and collaborators I've had the privilege to work with.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-charcoal-800/50 backdrop-blur-sm border border-beige-400/20 rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:border-beige-400/50 transition-all duration-300 group"
            >
              {/* Stars */}
              <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <HiStar key={i} className="text-beige-400 text-lg sm:text-xl" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 italic text-xs sm:text-sm md:text-base">
                "{testimonial.testimonial}"
              </p>

              <div className="border-t border-beige-400/20 pt-3 sm:pt-4">
                <h4 className="text-beige-300 font-bold font-primary text-sm sm:text-base">
                  {testimonial.name}
                </h4>
                <p className="text-xs sm:text-sm text-gray-400">{testimonial.role}</p>
                <p className="text-xs text-beige-500 mt-1">{testimonial.company}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* LinkedIn CTA */}
        <motion.div
          className="mt-10 sm:mt-12 md:mt-16 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a
            href="https://linkedin.com/in/wajiha-niazi-9b4991200"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-6 py-3 sm:px-8 sm:py-4 bg-beige-500 text-navy-900 font-semibold rounded-lg hover:bg-beige-400 transition-all duration-300 hover:scale-105 text-sm sm:text-base"
          >
            View More Recommendations on LinkedIn
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
